import appointmentService from '../../services/appointmentService'

class AppointmentController {
  fetchAppointment = appointmentService.fetchAppointment
  fetchAppointments = appointmentService.fetchAppointments
  fetchAppointmentWithNoCustomerData = appointmentService.fetchAppointmentWithNoCustomerData
  createAppointment = appointmentService.createAppointment
  updateAppointment = appointmentService.updateAppointment
  cancelAppointment = appointmentService.cancelAppointment
  fetchVideoToken = appointmentService.fetchVideoToken
}

export default new AppointmentController()
 


// WEBPACK FOOTER //
// ../src/controllers/appointmentController/appointmentController.js